import {useEffect} from 'react';
import {changeHeaderParent} from 'app/actions/headerActions';
import {DistrictChangeParentFactory} from 'app/models/appBar/DistrictChangeParentFactory';
import {useDispatch, useSelector} from 'react-redux';
import {reduxSelectDistrict} from 'app/hooks/reduxSelectDistrict';
import {DistrictUnsetParentFactory} from 'app/models/appBar/DistrictUnsetParentFactory';

export const useDistrictChangeAppBarParent = () => {
  const district = useSelector(reduxSelectDistrict);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!district?.name) {
      dispatch(changeHeaderParent(DistrictUnsetParentFactory.create()));
      return;
    }
    dispatch(changeHeaderParent(DistrictChangeParentFactory.create(district)));
  }, [dispatch, district]);
};
